import { render, staticRenderFns } from "./performance-observation-show.vue?vue&type=template&id=42b45d74"
import script from "./performance-observation-show.vue?vue&type=script&lang=js"
export * from "./performance-observation-show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports